require('jqmaskPlugin');

$.validator.addMethod(
    'zipValidation',
    (value, element) => {
      if ($(element).hasClass('required') === false) {
        return true;
      }

      if (value === undefined || value === null || value === '') {
        return false;
      }

      return (/^\d{4}[ ][a-zA-Z]{2}$/).test(value);
    }
);

$.validator.addMethod(
    'mobileValidation',
    (value, element) => {
      if ($(element).hasClass('required') === false) {
        return true;
      }

      if (value === undefined || value === null || value === '') {
        return false;
      }

      return (/^06[0-9]{8}$/).test(value);
    }
);

$(() => {
  $("[data-id='mobile']").mask('0699999999', { placeholder: '' });
  $("[data-id='zip']").mask('0000 SS', { clearIfNotMatch: true });
});



// WEBPACK FOOTER //
// ./js/countryForm/netherlands.form.js